import { useContext } from 'react';

import { EventFormContext } from './event-form-context';

export const useDuplicateEvent = () =>
  useContext(EventFormContext).onDuplicateEvent;
